module.exports = __webpack_public_path__ + "static/AngelaHe10-7a8eb194c11986e2ba6d7cf5dc8256fc.png";